export const MEETING_LIST_CONTAINER = 'meeting-list';

/** Width from which a meeting row lays its title, date and report out in columns. */
export const MEETING_LIST_WIDE_MIN_WIDTH = 720;

export const MEETING_LIST_WIDE_QUERY = `@container ${MEETING_LIST_CONTAINER} (min-width: ${MEETING_LIST_WIDE_MIN_WIDTH}px)`;

/** Side of the calendar tile (day + month), a comfortable 44px touch-sized square. */
export const MEETING_TILE_SIZE = 44;
